/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import Text from "./Text";
import Flex from "./Flex";
import Icon from "./Icon";
import Stack from "./Stack";
import styled from "styled-components";
import T from "./Translation";

const IconContainer = styled(Flex)`
  flex-shrink: 0;
  padding: 3px 0;
`;

const ItemQty = styled(Text)`
  flex-shrink: 0;
  align-self: center;
`;

export const PluginCardIncludeItem = ({ icon, name, label, qty, availableQty, totalQty, truncate, action }) => {
  const IconComponent = icon && React.cloneElement(icon, { color: "iconStroke" });

  return (
    <Flex $gap="0.25rem" $justify="space-between" $align="center">
      <Flex $gap="0.25rem" $align="center" style={{width: availableQty ? '75%' : '85%'}}>
        <IconContainer>{IconComponent}</IconContainer>
        {label ? (
          <Stack $gap="0" $padding="2px 0 0">
            <Text lineClamp={truncate}>{label}</Text>
            <Text color="dark" lineClamp={truncate}>{name}</Text>
          </Stack>
        ) : (
          <div style={{paddingTop: '2px'}}>
            <Text color="dark" lineClamp={truncate}>{name}</Text>
          </div>
        )}
      </Flex>
      {action || ((availableQty != null && totalQty != null || qty) && (
        <Flex $gap="2px" $align="center">
          <Text size="small">x</Text>
          <ItemQty>
            {availableQty != null && totalQty != null
              ? <>{availableQty} <T>of</T> {totalQty}</>
              : qty}
          </ItemQty>
        </Flex>
      ))}
    </Flex>
  );
};

// Items: [{ icon: <Icon.Clock />, name: string, label?: string, qty?: number }]
const PluginCardIncludes = ({ items = [], limit, truncate, stickyItem }) => {
  const visibleItems = limit != null ? items.slice(0, limit) : items;

  if (!visibleItems.length && !stickyItem) return null;

  return (
    <Flex $direction="column" $gap="0.25rem">
      {visibleItems.map((item, i) => (
        <PluginCardIncludeItem key={i} icon={item.icon} name={item.name} label={item.label} qty={item.qty} availableQty={item.availableQty} totalQty={item.totalQty} truncate={truncate} />
      ))}
      {stickyItem && (
        <PluginCardIncludeItem icon={stickyItem.icon} name={stickyItem.name} label={stickyItem.label} qty={stickyItem.qty} availableQty={stickyItem.availableQty} totalQty={stickyItem.totalQty} truncate={truncate} action={stickyItem.action} />
      )}
    </Flex>
  );
};

export default PluginCardIncludes;